import React, { FC, useEffect, useRef, useState } from 'react';
import styles from './SplashScreen.module.css';

interface Props {
    visible: boolean;
}

export const SplashScreen: FC<Props> = ({ visible }) => {
    const [mounted, setMounted] = useState(visible);
    const [progress, setProgress] = useState(0);
    const intervalRef = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        if (visible) {
            setMounted(true);
            setProgress(0);

            // fake progress: each tick adds 6% of the remaining gap to 90%, so it
            // naturally decreases speed and never actually reaches 90
            // jumps to 100 when visible becomes false (allSettings has loaded)
            intervalRef.current = setInterval(() => {
                setProgress((prev) => {
                    if (prev >= 90) {
                        clearInterval(intervalRef.current!);
                        return prev;
                    }
                    return prev + (90 - prev) * 0.06;
                });
            }, 100);
        } else {
            if (intervalRef.current) clearInterval(intervalRef.current);
            setProgress(100);
        }

        return () => {
            if (intervalRef.current) clearInterval(intervalRef.current);
        };
    }, [visible]);

    if (!mounted) return null;

    return (
        <div
            className={`${styles.splash} ${visible ? styles.visible : styles.hidden}`}
            onTransitionEnd={() => { if (!visible) setMounted(false); }}
        >
            <img src="/pwa-icon-192.png" alt="" className={styles.icon} />
            <div className={styles.progressTrack}>
                <div
                    className={styles.progressBar}
                    style={{ width: `${progress}%`, transition: progress === 100 ? 'width 0.2s ease' : 'width 0.1s linear' }}
                />
            </div>
        </div>
    );
};
